/* Supabase browser client — the single source of truth for the user's session.
 *
 * Login is 100% client-side (email OTP + Google); the backend only verifies the
 * JWT this client mints. Library defaults are what we want: the session is
 * persisted (localStorage) and the access token is auto-refreshed before it
 * expires, and the OAuth redirect is detected on return (PKCE flow). Because of
 * the auto-refresh, callers must read the token fresh from getSession() right
 * before each request rather than caching it — see src/api/client.ts. */
import { createClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from "../config";

if (!SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    "Missing SUPABASE_PUBLISHABLE_KEY. Copy .env.example to .env and set the " +
      "publishable key (Supabase Dashboard → Settings → API Keys), then restart `npm start`.",
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
